import { render, staticRenderFns } from "./quickdetails.vue?vue&type=template&id=998de41c&"
import script from "./quickdetails.vue?vue&type=script&lang=js&"
export * from "./quickdetails.vue?vue&type=script&lang=js&"
import style0 from "./quickdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports